








































































































































































import { Component, Vue } from 'vue-property-decorator';
import CustomAutocomplete from '@/vue-app/components/CustomAutocomplete.vue';
import UpdateProofOfAddressDataViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-proof-of-address/update-proof-of-address-data-view-model';

@Component({
  name: 'UpdateProofOfAddressData',
  components: {
    CustomAutocomplete,
  },
})
export default class UpdateProofOfAddressData extends Vue {
  update_address_data_view_model = Vue.observable(
    new UpdateProofOfAddressDataViewModel(this),
  );

  async mounted() {
    await this.update_address_data_view_model.initialize();
  }
}
